import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section id="precio" className="py-14 px-4 bg-[#0a0a0a] border-t border-zinc-900" style={{
    paddingTop: '5px',
    paddingBottom: '5px'
  }} data-id="element-58">
      <div className="max-w-4xl mx-auto text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-zinc-900 to-black border border-zinc-800 p-6 md:p-10 rounded-3xl relative overflow-hidden" data-id="element-60">
          {/* Glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-61" />

          <img src="https://cdn.magicpatterns.com/uploads/vtn2W9TKEXtgptZy6aarG2/alquila_sin_que_te_estafen_mockup.png" alt="Alquilá sin que te estafen - Protocolo 3C + Carpeta Lista" className="mx-auto mb-8 max-w-xs md:max-w-sm w-full relative z-10 drop-shadow-2xl" data-id="element-62" />

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 relative z-10" data-id="element-63">
            Este kit cuesta menos que <br data-id="element-64" />
            <span className="text-amber-500" data-id="element-65">una seña mal hecha.</span>
          </h2>

          <div className="flex items-baseline justify-center gap-2 mb-6 relative z-10" data-id="element-66">
            <span className="text-zinc-500 text-xl line-through" data-id="element-67">$1194</span>
            <span className="text-6xl font-black text-white tracking-tighter" data-id="element-68">
              $597
            </span>
            <span className="text-zinc-400 font-medium" data-id="element-69">UYU</span>
          </div>

          <p className="text-zinc-400 mb-8 max-w-md mx-auto relative z-10" data-id="element-70">
            Lo usás en cada propiedad. Te queda para siempre. <br data-id="element-71" />
            <span className="text-zinc-300" data-id="element-72">
              Incluye actualizaciones de por vida.
            </span>
          </p>

          <div className="flex flex-col items-center gap-4 relative z-10" data-id="element-73">
            <Button size="lg" href="https://factorclaro.com/cart/45270142386355:1" className="w-full md:w-auto text-lg px-12 py-6 shadow-amber-500/20 shadow-lg" data-id="element-74">
              <DownloadIcon className="mr-2 w-5 h-5" data-id="element-75" />
              Descargá el Kit Ahora
            </Button>
            <p className="text-sm text-zinc-500" data-id="element-76">
              Alquilá con la cabeza fría, aunque estés apurado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}